import { readonly, ref, watchEffect } from 'vue';
import { autoUpdate, flip, offset, shift, useFloating } from '@floating-ui/vue';

export const usePopper = (
  popperElement: Parameters<typeof useFloating>[1],
  relativeTo: Parameters<typeof useFloating>[0],
) => {
  const isOpen = ref(false);
  const { floatingStyles: popperStyles, update } = useFloating(relativeTo, popperElement, {
    placement: 'bottom-start',
    middleware: [offset(4), flip(), shift()],
    whileElementsMounted: autoUpdate,
  });

  watchEffect(() => {
    if (!isOpen.value || !popperElement.value || !relativeTo.value) {
      return;
    }

    if (isOpen.value) {
      update();
    }
  });

  const open = () => {
    isOpen.value = true;
  };

  const close = () => {
    isOpen.value = false;
  };

  const toggle = () => {
    isOpen.value = !isOpen.value;
  };

  return {
    isOpen: readonly(isOpen),
    open,
    close,
    toggle,
    popperStyles,
  };
};
